var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "download-more-page" },
    [
      _c("headerTop"),
      _vm._v(" "),
      _c("div", { staticClass: "download-more-container" }, [
        _c("div", { staticClass: "download-app" }, [
          _c("h1", [_vm._v(_vm._s(_vm.$t("300248")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("300249")))]),
          _vm._v(" "),
          _c("div", { staticClass: "flex-between" }, [
            _c("div", { staticClass: "qrcode-box" }, [
              _c("div", { attrs: { id: "qrcode" } }),
              _vm._v(" "),
              _c("p", { domProps: { innerHTML: _vm._s(_vm.$t("300253")) } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "link-box" }, [
              _c("div", { staticClass: "flex-between" }, [
                _c(
                  "div",
                  {
                    staticClass: "flex",
                    on: {
                      click: function($event) {
                        return _vm.goLink(_vm.downloadUrl.appStore)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "iconfont icon-ios1" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "block" }, [_vm._v("App Store")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex",
                    on: {
                      click: function($event) {
                        return _vm.goLink(_vm.downloadUrl.TFLink)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "iconfont icon-ios1" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "block" }, [_vm._v("TestFlight")])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex-between" }, [
                _c(
                  "div",
                  {
                    staticClass: "flex",
                    on: {
                      click: function($event) {
                        return _vm.goLink(_vm.downloadUrl.googlePlay)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "iconfont icon-guge2" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "block" }, [
                      _vm._v("Google Play")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex",
                    on: {
                      click: function($event) {
                        return _vm.goLink(_vm.downloadUrl.androidApk)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "iconfont icon-anzhuo3" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "block" }, [
                      _vm._v("Android APK")
                    ])
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: { src: require("../../static/images/img1.png"), alt: "" }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "download-auth" }, [
          _c("h1", [_vm._v(_vm._s(_vm.$t("300254")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("300255")))]),
          _vm._v(" "),
          _c("div", { staticClass: "select-box" }, [
            _c("div", { staticClass: "select-item relative pointer" }, [
              _c(
                "div",
                {
                  staticClass: "flex-between",
                  on: {
                    click: function($event) {
                      _vm.show1 = !_vm.show1
                      _vm.show2 = false
                      _vm.show3 = false
                    }
                  }
                },
                [
                  _vm._v(_vm._s(_vm.$t("300256")) + " "),
                  _c("i", {
                    staticClass: "iconfont",
                    class: _vm.show1 ? "icon-shangla" : "icon-xiala"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.show1,
                      expression: "show1"
                    }
                  ],
                  staticClass: "dropdown-box absolute"
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "block flex-center",
                      attrs: {
                        href:
                          "https://apps.apple.com/us/app/superex-authenticator/id6443871151",
                        target: "_blank"
                      }
                    },
                    [
                      _c("i", { staticClass: "iconfont icon-ios1" }),
                      _vm._v(" "),
                      _c("em", { staticClass: "normal inline-block" }, [
                        _vm._v(_vm._s(_vm.$t("300259")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "block flex-center",
                      attrs: {
                        href:
                          "https://play.google.com/store/apps/details?id=com.superex.auth",
                        target: "_blank"
                      }
                    },
                    [
                      _c("i", { staticClass: "iconfont icon-anzhuo3" }),
                      _vm._v(" "),
                      _c("em", { staticClass: "normal inline-block" }, [
                        _vm._v(_vm._s(_vm.$t("300260")))
                      ])
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "select-item relative pointer" }, [
              _c(
                "div",
                {
                  staticClass: "flex-between",
                  on: {
                    click: function($event) {
                      _vm.show2 = !_vm.show2
                      _vm.show1 = false
                      _vm.show3 = false
                    }
                  }
                },
                [
                  _vm._v(_vm._s(_vm.$t("300257")) + " "),
                  _c("i", {
                    staticClass: "iconfont",
                    class: _vm.show2 ? "icon-shangla" : "icon-xiala"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.show2,
                      expression: "show2"
                    }
                  ],
                  staticClass: "dropdown-box absolute"
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "block flex-center",
                      attrs: {
                        href:
                          "https://apps.apple.com/us/app/google-authenticator/id388497605",
                        target: "_blank"
                      }
                    },
                    [
                      _c("i", { staticClass: "iconfont icon-ios1" }),
                      _vm._v(" "),
                      _c("em", { staticClass: "normal inline-block" }, [
                        _vm._v(_vm._s(_vm.$t("300259")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "block flex-center",
                      attrs: {
                        href:
                          "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
                        target: "_blank"
                      }
                    },
                    [
                      _c("i", { staticClass: "iconfont icon-anzhuo3" }),
                      _vm._v(" "),
                      _c("em", { staticClass: "normal inline-block" }, [
                        _vm._v(_vm._s(_vm.$t("300260")))
                      ])
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "select-item relative pointer" }, [
              _c(
                "div",
                {
                  staticClass: "flex-between",
                  on: {
                    click: function($event) {
                      _vm.show3 = !_vm.show3
                      _vm.show2 = false
                      _vm.show1 = false
                    }
                  }
                },
                [
                  _vm._v(_vm._s(_vm.$t("300258")) + " "),
                  _c("i", {
                    staticClass: "iconfont",
                    class: _vm.show3 ? "icon-shangla" : "icon-xiala"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.show3,
                      expression: "show3"
                    }
                  ],
                  staticClass: "dropdown-box absolute"
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "block flex-center",
                      attrs: {
                        href:
                          "https://apps.apple.com/us/app/microsoft-authenticator/id983156458",
                        target: "_blank"
                      }
                    },
                    [
                      _c("i", { staticClass: "iconfont icon-ios1" }),
                      _vm._v(" "),
                      _c("em", { staticClass: "normal inline-block" }, [
                        _vm._v(_vm._s(_vm.$t("300259")))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "block flex-center",
                      attrs: {
                        href:
                          "https://play.google.com/store/apps/details?id=com.azure.authenticator",
                        target: "_blank"
                      }
                    },
                    [
                      _c("i", { staticClass: "iconfont icon-anzhuo3" }),
                      _vm._v(" "),
                      _c("em", { staticClass: "normal inline-block" }, [
                        _vm._v(_vm._s(_vm.$t("300260")))
                      ])
                    ]
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: { src: require("../../static/images/img2.png"), alt: "" }
          })
        ])
      ]),
      _vm._v(" "),
      _c("footerView")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4036591e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4036591e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/downloadMore.vue
// module id = H2W6
// module chunks = 0